// transloco.module.ts
import { NgModule, Injectable } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import {
    TranslocoModule,
    TranslocoService,
    TRANSLOCO_CONFIG,
    TRANSLOCO_LOADER,
    TRANSLOCO_TRANSPILER,
    TRANSLOCO_MISSING_HANDLER,
    TRANSLOCO_INTERCEPTOR,
    TRANSLOCO_FALLBACK_STRATEGY,
    DefaultTranspiler,
    translocoConfig,
    TranslocoLoader
} from '@ngneat/transloco';
import { Observable } from 'rxjs';

// --- HTTP loader ---
@Injectable()
class InlineHttpLoader implements TranslocoLoader {
    constructor(private http: HttpClient) { }
    getTranslation(lang: string): Observable<Record<string, any>> {
        return this.http.get<Record<string, any>>(`./assets/i18n/${lang}.json`);
    }
}

// --- Missing handler ---
@Injectable({ providedIn: 'root' })
class CustomMissingHandler {
    handle(params: any) {
        return params?.key ?? '';
    }
}

// --- Interceptor ---
@Injectable({ providedIn: 'root' })
class SimpleTranslocoInterceptor {
    intercept(value: string, key: string, lang: string, params?: any): string {
        return value;
    }
}

// --- Fallback strategy ---
@Injectable({ providedIn: 'root' })
class SimpleFallbackStrategy {
    // get fallback translation
    get(lang: string, key: string): string | null {
        // return key itself or null
        return key;
    }
}

// --- App initializer ---
export function initTranslocoFactory(transloco: TranslocoService) {
    const defaultLang = 'cz';
    return () => transloco.load(defaultLang).toPromise().then(() => transloco.setActiveLang(defaultLang));
}

@NgModule({
    imports: [TranslocoModule, HttpClientModule],
    exports: [TranslocoModule],
    providers: [
        {
            provide: TRANSLOCO_CONFIG, useValue: translocoConfig({
                availableLangs: [
                    { id: 'cz', label: 'Česky' },
                    { id: 'en', label: 'English' },
                    { id: 'sk', label: 'Slovensky' }
                ],
                defaultLang: 'cz',
                fallbackLang: 'cz',
                reRenderOnLangChange: true,
                prodMode: true
            })
        },
        { provide: TRANSLOCO_LOADER, useClass: InlineHttpLoader, deps: [HttpClient] },
        { provide: TRANSLOCO_TRANSPILER, useClass: DefaultTranspiler },
        { provide: TRANSLOCO_MISSING_HANDLER, useClass: CustomMissingHandler },
        { provide: TRANSLOCO_INTERCEPTOR, useClass: SimpleTranslocoInterceptor },
        { provide: TRANSLOCO_FALLBACK_STRATEGY, useClass: SimpleFallbackStrategy },
        { provide: 'APP_INITIALIZER', useFactory: initTranslocoFactory, deps: [TranslocoService], multi: true }
    ]
})
export class TranslocoCoreModule { }